import { DateTime } from "luxon"

export enum CustomReportsType {
    ACCOUNTING = "ACCOUNTING",
    REPORT = "REPORT",
    IMPORT = "IMPORT",
}
export type CustomJob = Readonly<{
    id: number
    uid: string
    name: string
    interval?: string
    isActive: boolean
    lastRunTime?: string
    status: string
    type: CustomReportsType
}>

export type RunFormValues = Readonly<{
    startDate: DateTime
    endDate: DateTime
}>
